module.exports = __webpack_public_path__ + "static/media/layoutBg.9bd7a17c.png";